import { useState } from 'react';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import * as React from 'react';
export default {
  useState,
  ContactPhoneIcon,
  React
};